import { ReportingActions } from '@/modules/reporting/store/actions';
import { ReportingGetters } from '@/modules/reporting/store/getters';
import { ReportingMutations } from '@/modules/reporting/store/mutations';
import {
  ReportingState,
  IReportingState
} from '@/modules/reporting/store/state';
import { IRootState } from '@/store/state';
import { Module, Store, StoreOptions } from 'vuex';

export const ReportingModuleStore: IReportingModuleStore = {
  state: ReportingState,
  actions: ReportingActions,
  getters: ReportingGetters,
  mutations: ReportingMutations
};

/**
 * --------------------------------------------------
 *	Reporting Store Interface
 * --------------------------------------------------
 **/
export interface IReportingModuleStore
  extends Module<IReportingState, IRootState> {}
